Object.defineProperty(exports, "__esModule", { value: true });
var math_1 = require("./math");
function distance(x1, y1, x2, y2) {
    return math_1.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
}
exports.distance = distance;
